import styled, { css } from "styled-components";
import { transition } from "@m/alchemy-theme";
import { FocusList } from "../utilities/focus-list/FocusList";
import { IS_FIRST_ROW_CLASS_NAME, IS_LAST_ROW_CLASS_NAME, IS_WRAPPED_ROW_CLASS_NAME } from "../hooks/useTagRowWraps";
import { ToolbarGroup } from "./ToolbarGroup";
import { ToolbarButton, ToolbarLinkButton } from "./ToolbarButton.styled";
export const Toolbar = styled(FocusList) `
  --aui-toolbar-divider-margin: ${(props) => (props.$size === "medium" ? "10px" : "5px")};
  min-height: 41px;
  padding: 4px 8px;
  align-items: center;
  transition: ${transition("base", "opacity")};
  margin-left: 0;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  gap: 2px 2px;

  &[inert],
  &[aria-hidden="true"] {
    opacity: 0.5;
  }

  &,
  ${ToolbarGroup} {
    justify-content: ${({ $align }) => $align ?? "flex-start"};
  }

  ${ToolbarGroup}.${IS_FIRST_ROW_CLASS_NAME}:not(.${IS_LAST_ROW_CLASS_NAME}),
  ${ToolbarGroup}.${IS_WRAPPED_ROW_CLASS_NAME}:not(.${IS_LAST_ROW_CLASS_NAME}) {
    ${(props) => {
    if (props.$align === "end") {
        return css `
          transform: translateX(calc(var(--aui-toolbar-divider-margin) * 2));
        `;
    }
    if (props.$align === "center") {
        return css `
          transform: translateX(var(--aui-toolbar-divider-margin));
        `;
    }
    return "";
}}
  }

  ${(props) => {
    if (props.$size === "medium") {
        return css `
        gap: 4px 12px;

        ${ToolbarLinkButton},
        ${ToolbarButton} {
          height: 36px;
          min-width: 36px;
          padding: 6px 12px;

          svg {
            width: 24px;
            height: 24px;
          }
        }
      `;
    }
    return "";
}}
`;
